import { GridValueFormatterParams } from '@mui/x-data-grid/models/params/gridCellParams';

export const numberFormatter = ({
  value,
}: GridValueFormatterParams<number>) => {
  return value ? value.toLocaleString() : '-';
};
